import { render, staticRenderFns } from "./CompanyVue.vue?vue&type=template&id=705ca388&"
import script from "./CompanyVue.vue?vue&type=script&lang=js&"
export * from "./CompanyVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports